import { FC, useEffect, useState } from "react";
import { webAPI } from "../../api/Api";
import ExpandedTable from "../ExpandedTable";
import { IAntTableScroll } from "../ExpandedTable/ExpandedTable";
import { mapHistoryData } from "../../utils/helpers/mapping.helpers";

interface IProps {
  historyUrl: string;
  ruNames?: {
    [index: string]: string;
  };
  scroll?: IAntTableScroll;
}

const HistoryTable: FC<IProps> = ({ historyUrl, ruNames, scroll }) => {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const tableCols = [
    {
      title: "Дата изменения",
      dataIndex: "date",
    },
    {
      title: "Поле",
      dataIndex: "name",
      render: (_, record) => ruNames?.[record.name] ?? record.name,
      width: "25%",
    },
    {
      title: "Старое значение",
      dataIndex: "valueBefore",
      align: "left",
      width: "25%",
    },
    {
      title: "Новое значение",
      dataIndex: "valueAfter",
      align: "left",
      width: "25%",
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    webAPI.get(historyUrl).then((res) => {
      const changes = mapHistoryData(res.data);
      setHistory(changes);
      setIsLoading(false);
    });
  }, [historyUrl]);

  return (
    <div>
      <ExpandedTable
        data={history}
        columns={tableCols}
        loading={isLoading}
        scroll={scroll}
      />
    </div>
  );
};

export default HistoryTable;
